import Page from "../../components/Page";
import useSpectraList from "./hooks/useSpectraList";
const SpectraList = () => {
  const page = useSpectraList();
  return <Page {...page} />;
};

export default SpectraList;
